import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/node_modules/react-international-phone/dist/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsScripts"] */ "/vercel/path0/frontend_next/src/components/AnalyticsScripts.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/components/layout/UserLayout.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/components/layout/DashboardLayout.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/frontend_next/src/components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/components/ui/Button.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/components/ui/Card.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/components/ui/Input.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/components/ui/Loader.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/components/ui/LanguageSwitcher.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/components/ui/FloatingContacts.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/components/ui/CookieConsent.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/components/ui/RichTextEditor.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/screens/auth/Login.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/screens/dashboard/AdminPages.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/screens/user/About.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/screens/user/Blog.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/screens/user/BlogPost.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/screens/user/Home.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/screens/user/InfoPage.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/screens/user/LegalPage.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/screens/user/Team.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend_next/src/screens/user/TeamMember.css");
